module.exports = "/assets/images/8dd6e13d91214fb7b4351a8b3bcd985b.jpg";